import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Button } from '@blueprintjs/core/lib/cjs/components/button/buttons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSort } from '@fortawesome/pro-regular-svg-icons/faSort'
import { faSortUp } from '@fortawesome/pro-regular-svg-icons/faSortUp'
import { faSortDown } from '@fortawesome/pro-regular-svg-icons/faSortDown'

import styles from './list.module.scss'

class List extends Component {
    static propTypes = {
        /**
         * Configure how header should look and provides the ability to
         * provide custom component for rendering a cell value
         */
        config: PropTypes.arrayOf(
            PropTypes.shape({
                /**
                 * Unique identifier used when rendering the elements by using map function
                 */
                id: PropTypes.string.isRequired,
                /**
                 * Header name
                 */
                name: PropTypes.string,
                /**
                 * Key name of the object value which needs to be rendered
                 */
                accessor: PropTypes.string,
                /**
                 * The width of the header and it's corresponding cell
                 */
                width: PropTypes.string,
                /**
                 * Function which should return a JSX element. Two parameters can
                 * be provided to it:
                 * - [cell] - represents the actual value
                 * - [row] - represents the entire row values as object
                 */
                cell: PropTypes.func,
            }).isRequired
        ).isRequired,
        data: PropTypes.array.isRequired,
        headerClassName: PropTypes.string,
        rowClassName: PropTypes.string,
    }

    render() {
        const {
            data,
            config,
            sortBy,
            sortDirection,
            onSort,
            headerClassName,
            rowClassName,
        } = this.props

        const headerClasses = [styles.header, headerClassName]
            .filter(Boolean)
            .join(' ')
        const rowClasses = [styles.listItem, rowClassName]
            .filter(Boolean)
            .join(' ')

        return (
            <div className={styles.root}>
                <div className={headerClasses}>
                    {config.map((header) => (
                        <div
                            key={`header-${header.id}`}
                            style={{ flexBasis: header.width ?? null }}
                            className={styles.headerCell}
                        >
                            {header.name ? (
                                header.sortable ? (
                                    <Button
                                        className={styles.nakedBtn}
                                        key={header.name}
                                        onClick={() =>
                                            onSort(
                                                header.sortColumn ??
                                                    header.accessor
                                            )
                                        }
                                    >
                                        {header.name}
                                        {sortBy ===
                                        (header.sortColumn ??
                                            header.accessor) ? (
                                            sortDirection === 1 ? (
                                                <FontAwesomeIcon
                                                    icon={faSortUp}
                                                    className={styles.sortIcon}
                                                />
                                            ) : (
                                                <FontAwesomeIcon
                                                    icon={faSortDown}
                                                    className={styles.sortIcon}
                                                />
                                            )
                                        ) : (
                                            <FontAwesomeIcon
                                                icon={faSort}
                                                className={styles.sortIcon}
                                            />
                                        )}
                                    </Button>
                                ) : (
                                    <Button
                                        className={`${styles.nakedBtn} ${styles.nakedBtnStatic}`}
                                        key={header.name}
                                        aria-hidden
                                    >
                                        {header.name}
                                    </Button>
                                )
                            ) : null}
                        </div>
                    ))}
                </div>

                <ul className={styles.list}>
                    {data.map((listItem, rowIndex) => (
                        <li key={listItem.id} className={rowClasses}>
                            {config.map((header) => (
                                <div
                                    key={`item-${header.id}`}
                                    style={{ flexBasis: header.width ?? null }}
                                >
                                    {header.cell
                                        ? header.cell({
                                              cell: listItem[header.accessor],
                                              row: listItem,
                                              rowIndex,
                                              rowCount: data.length,
                                          })
                                        : listItem[header.accessor] ?? '-'}
                                </div>
                            ))}
                        </li>
                    ))}
                </ul>
            </div>
        )
    }
}

export default List
